"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSocialLinksInstance = void 0;
const social_links_1 = __importDefault(require("social-links"));
const constants_1 = require("../constants");
const enums_1 = require("../enums");
const socialLinks = new social_links_1.default();
const exampleProfileId = 'OkLetsPlayPlayer';
// This override of methods is done due to limitations of adding validations
//   of Discord links to the 'social-links' package functionality.
const getSocialLinksInstance = () => ({
    isValid: (profileName, link) => {
        if (!link || link.length > constants_1.MAX_LINK_LENGTH) {
            return false;
        }
        if (profileName === enums_1.SocialNetwork.Discord) {
            return constants_1.DISCORD_USERNAME_REGEXP.test(link);
        }
        return socialLinks.isValid(profileName, link);
    },
    getExampleLink: (profileName) => {
        if (profileName === enums_1.SocialNetwork.Discord) {
            return `${exampleProfileId}#1234`;
        }
        return socialLinks.getLink(profileName, exampleProfileId);
    },
    buildLink: (profileName, linkOrProfileId, type) => {
        if (profileName === enums_1.SocialNetwork.Discord) {
            return linkOrProfileId;
        }
        const profileId = socialLinks.getProfileId(profileName, linkOrProfileId);
        return socialLinks.getLink(profileName, profileId, type);
    },
});
exports.getSocialLinksInstance = getSocialLinksInstance;
//# sourceMappingURL=social-links-instance.js.map